export type GeoCoordinates = {
    latitude: number;
    longitude: number;
} | null;

export type UserData = {
    ANMS: number;
    acceptedTermsOfService: string;
    address: string;
    address2: string;
    bidderId: number;
    city: string;
    country: string;
    createdDate: string;
    creditCardValidated: boolean;
    email: string;
    firstName: string;
    hasEverRegisteredForAuction: boolean;
    lastName: string;
    mobileNumber: string;
    phoneNumber: string;
    preferredCurrency: string;
    premiumBidder: boolean;
    profileComplete: boolean;
    standing: string;
    state: string;
    upcomingBids?: number;
    username: string;
    zip: string;
    zipCodeGeoCoordinates: GeoCoordinates;
};

export const EmptyUserData: UserData = {
    acceptedTermsOfService: '',
    address: '',
    address2: '',
    ANMS: 0,
    bidderId: -1,
    city: '',
    country: '',
    createdDate: '',
    creditCardValidated: false,
    email: '',
    firstName: '',
    hasEverRegisteredForAuction: false,
    lastName: '',
    mobileNumber: '',
    phoneNumber: '',
    preferredCurrency: 'USD',
    premiumBidder: false,
    profileComplete: false,
    standing: '',
    state: '',
    upcomingBids: 0,
    username: '',
    zip: '',
    zipCodeGeoCoordinates: null,
};
